import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiSwitch} from '@elastic/eui';
import { stringToFloat } from '../../../../../shared/utils/numbers';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [concepto,setConcepto] = useState(selected ? selected.concepto : undefined)
  let [esIngenieria,setEsIngenieria] = useState(selected ? selected.esIngenieria : false)
  let [margen, setMargen] = useState(selected ? selected.margen.toString() : undefined)

  const getData = () =>{
    let data={concepto: concepto, esIngenieria: esIngenieria, margen: stringToFloat(margen)}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidConcepto || isInvalidMargen)
  }

  const isInvalidConcepto = useMemo(() => {return concepto===undefined || concepto.trim()===""},[concepto])
  const isInvalidMargen = useMemo(() => {return margen===undefined || margen.trim()===""},[margen])


  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Concepto" isInvalid={isInvalidConcepto}>
            <EuiFieldText fullWidth value={concepto} name="txtConcepto" onChange={e => setConcepto(e.target.value)} isInvalid={isInvalidConcepto}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
          <EuiFormRow label="Margen (%)" isInvalid={isInvalidMargen}>
            <EuiFieldText value={margen} name="txtMargen" onChange={e => setMargen(e.target.value)} isInvalid={isInvalidMargen}/>
          </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiFormRow label="Ingeniería">
          <EuiSwitch checked={esIngenieria} name="chkIngenieria" onChange={e => setEsIngenieria(!esIngenieria)} style={{marginTop: "10px"}}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;